import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadType } from '../../enums/upload-type.enum';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class BadgeFileService extends FileService {
  override uploadType = UploadType.BADGE;

  badgeId: number | null = null;

  setBadgeId(id: number | null) {
    this.badgeId = id;
  }

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  override uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormRequest(
      `egrowe/rubric-builder/badge-graphic/${this.badgeId}`,
      formData,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }
}
